/**
 * Ecomail Basket Tracking
 * Odesílá obsah košíku do Ecomailu při změně (přidání/odebrání produktu)
 */

window.EcomailBasket = {
    /**
     * Odeslání dat košíku do Ecomailu
     * @param {Array} products - pole produktů v košíku
     */
    trackBasket: function(products) {
        if (typeof window.ecotrack === 'undefined') {
            console.warn('Ecomail tracker není načten');
            return;
        }

        // Ověření, že máme data
        if (!products || !Array.isArray(products)) {
            console.warn('Chybí data košíku pro Ecomail tracking');
            return;
        }

        // Limit počtu produktů (doporučení Ecomailu)
        const maxProducts = 10;
        const limitedProducts = products.slice(0, maxProducts);

        try {
            window.ecotrack('trackUnstructEvent', {
                schema: '',
                data: {
                    action: 'Basket',
                    products: limitedProducts
                }
            });
            
            console.log('Ecomail: Košík trackován', limitedProducts);
        } catch (error) {
            console.error('Chyba při trackování košíku do Ecomailu:', error);
        }
    }
};
